import React, { useCallback, useEffect, useState } from "react";
import { SearchBox } from "../../../../components/Search";
import { Download } from "lucide-react";
import { useSelector } from "react-redux";
import ModHeader from "../Mod/ModTable/ModHeader";
import ToggleTabs from "../Mod/ModTable/ChartTableToggle";
import loader from "../../../../components/recharts/loader.gif";
import { BidTable } from "./BidTable";
import BidChart from "./BidChart";
import "./BidIndex.css";
import { ModUpdateBidData, fetchModBidTableData } from "../../Utility/RestApi";
import Loading from "../../../../components/Loading";
import Tooltip from "../../../../components/tooltip";
import { BASE_URL } from "../../../../configs";
import BlockRangeSelector from "../../../../components/BlockRangeSelector/BlockRangeSelector";
import Modal from "../../../Rajasthan/MeritOrderDispatch/Bid/Modal";
import { DeficitBidTable } from "./DeficitEdit";
import { ReactComponent as Edit } from "../../../../icons/edit_solid.svg";
import { useMeritEngineNavigation } from "../useMeritEngineNavigation";
import MainHeader from "../DateSession";
import { ErrorPopup } from "../../../../components/ErrorHandling";
import { downloadFile } from "../../../../components/DownloadFile";
import { getAccessToken } from "../../../Protected";
const DataTabs = ["chart", "table"];
const DataBidTabs = ["buy Bids", "sell Bids"];

interface GeneratorData {
  generator: string;
  bid: number;
  isBuy: boolean;
  price: number;
  quantum: number;
  time_slot__slot: number;
  time_string: string;
  // date: string;
  // demand_mw: number;
  // must_run: number;
}

export default function SellBidTable() {
  const [activeTab, setActiveTab] = useState(DataTabs[1]);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [uniqueBlock, setUniqueBlock] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [data, setData] = useState<GeneratorData[]>([]);
  const { navigateToPage } = useMeritEngineNavigation();

  const [bidData, setBidData] = useState<GeneratorData[]>([]);
  const [uniqueGeneratorName, setUniqueGeneratorName] = useState<any[]>([]);
  const [selectedGeneratorName, setSelectedGeneratorName] = useState<any[]>([]);
  const preSelectedDate = useSelector(
    (state: any) => state.modCSPDCLDate.selectedDate
  );
  const modSelectedSession = useSelector(
    (state: any) => state.modCSPDCLSession.modSession
  );
  const [activeBidTab, setActiveBidTab] = useState(DataBidTabs[0]);

  // const downloadTable = () => {
  //   const table = document.getElementById("my-table");
  //   const worksheet = XLSX.utils.table_to_sheet(table);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  //   XLSX.writeFile(workbook, "Bid_table.xlsx");
  // };

  const handleFetchData = useCallback(async () => {
    setLoading(true);
    if (!preSelectedDate || !modSelectedSession) return;
    try {
      const res = await fetchModBidTableData(
        preSelectedDate,
        modSelectedSession
      );

      if (res) {
        let data = res.data;
        setData(data);
        setUniqueBlock(
          Array.from(
            new Set(
              data.map((item: { time_slot__slot: any }) => item.time_slot__slot)
            )
          )
        );
        setUniqueGeneratorName(
          Array.from(
            new Set(res.data.map((item: { generator: any }) => item.generator))
          )
        );
      } else {
        setError("Failed");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  }, [modSelectedSession, preSelectedDate]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData]);

  useEffect(() => {
    let filterData = data;
    filterData = data.filter((item) =>
      activeBidTab === "buy Bids" ? item.isBuy : !item.isBuy
    );
    if (selectedBlock.length > 0) {
      filterData = filterData.filter((row: { time_slot__slot: any }) =>
        selectedBlock
          .map((block) => Number(block.value))
          .includes(Number(row.time_slot__slot))
      );
    }
    if (selectedGeneratorName.length > 0) {
      const generator = selectedGeneratorName.map((o: any) => o.value ?? o);
      filterData = filterData.filter((row) =>
        generator.includes(row.generator)
      );
    }
    setBidData(filterData);
  }, [selectedBlock, data, activeBidTab, selectedGeneratorName]);

  const downloadTable = async () => {
    setError(null);
    await downloadFile({
      url: `${BASE_URL}/mod_gridco/getBidDownload?date=${preSelectedDate}&session=${modSelectedSession}`,
      filename: `Gridco_Bid_Table_${preSelectedDate}.xlsx`,
      headers: {
        Authorization: `${getAccessToken() || ""}`,
      },
      onSuccess: () => setLoading(false),
      onError: (err) => {
        setError("Failed to download Excel file. Please try again later.");
      },
    });
  };

  const GotoSimulation = () => {
    navigateToPage("simulation-generation");

  };

  async function handleUpdateReview(data: any) {
    try {
      setSubmitLoading(true);
      await ModUpdateBidData({
        date: preSelectedDate,
        session: modSelectedSession,
        data: data,
      });
      handleFetchData();
      setModalOpen(false);
      // setModalFilter(false);
    } catch (error) {
      setError("Failed to update Deficit data");
      console.error("Error updating Deficit data:", error);
    } finally {
      setSubmitLoading(false);
    }
  }

  return (
    <div className="page-wrapper">
      <div className="flex flex-col w-full">
        {loading && <Loading />}
        <MainHeader />
        <div className="tabContent ">
          {" "}
          <div className="h-[calc(-73px+100vh)] p-4">
            <div className="w-full h-full flex flex-col gap-4">
              <ModHeader title="DAM Bid Catalogue" />
              <div className="gas-chart-container !gap-1">
                <div className="flex justify-between items-center mb-2 border-b border-[#DFEAF2] pb-2">
                  <div className="flex items-center gap-3">
                    <ToggleTabs
                      tabs={DataTabs}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                    />
                    <BlockRangeSelector
                      blocks={Array.from({ length: 96 }, (_, i) => i + 1)}
                      placeholder="Select Block"
                      selectedOptions={selectedBlock.map((item) => item.value)}
                      setSelectedOptions={setSelectedBlock}
                    />
                    <SearchBox
                      options={uniqueGeneratorName.map((item) => ({
                        value: item,
                        label: item,
                      }))}
                      isMany={true}
                      placeholder="Generator Name"
                      selectedOptions={selectedGeneratorName}
                      onChange={setSelectedGeneratorName}
                    />
                  </div>
                  <div className="flex gap-3 justify-end">
                    {activeTab === "table" && (
                      <ToggleTabs
                        tabs={DataBidTabs}
                        activeTab={activeBidTab}
                        setActiveTab={setActiveBidTab}
                      />
                    )}
                    {activeBidTab === "buy Bids" && (
                      <button
                        onClick={() => setModalOpen(true)}
                        className="flex items-center gap-2 p-2 text-sm rounded-xl border border-[#34656D] bg-[#EFFCFF] text-[#34656D] font-medium"
                      >
                        <Edit className="w-5 h-5" />
                        Deficit Modify
                      </button>
                    )}

                    <button
                      onClick={downloadTable}
                      className="flex items-center gap-2 p-2 text-sm rounded-xl bg-[#FFFAF6] text-[#F1935C] font-medium border border-[#F1935C]"
                    >
                      <span>Download Data</span>
                      <Download className="w-5 h-5" />
                    </button>
                    {/* <button
                      onClick={GotoSimulation}
                      className="flex items-center gap-2 p-2 text-sm rounded-xl disabled:text-[#A9A8B1] disabled:bg-[#E2E2E5] bg-[#F1935C] text-white font-medium"
                    >
                      Simulate Session
                    </button> */}
                  </div>
                </div>

                <div className="chartTable h-100">
                  {loading ? (
                    <div className="h-full w-full bg-white flex items-center justify-center">
                      <img
                        src={loader}
                        width={200}
                        alt="loader"
                        className="block mt-[5rem]"
                      />
                    </div>
                  ) : (
                    <>
                      {activeTab === "table" && <BidTable data={bidData} />}
                      {activeTab === "chart" && (
                        <BidChart
                          selectedBlock={selectedBlock}
                          selectedGeneratorName={selectedGeneratorName}
                          data={data}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
              <ErrorPopup error={error} onClose={() => setError(null)} />
              <div className="gna-footer-container">
                <div className="grid grid-cols-3 justify-between gap-5 ">
                  <Tooltip
                    note={<p>System has computed only single bids.</p>}
                    text="1. Each block reflects the cumulative bid quantity and the average bid price."
                  >
                    <p className="gna-footer-text">Source</p>
                  </Tooltip>
                  <p className="gna-footer-text col-span-1 text-center">
                    Powered by <strong>GNA Energy</strong>
                  </p>
                  <strong className="gna-footer-text col-span-1 text-end">
                    Beta Version
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={isModalOpen} onClose={() => setModalOpen(true)}>
          <div className="w-full">
            <div className="h-[calc(-73px+100vh)]">
              <div className="w-full h-full flex flex-col gap-4">
                <div
                  className="gas-chart-container"
                  style={{
                    height: "calc(-60px + 100vh)",
                    borderRadius: "0px!important",
                  }}
                >
                  <div className="gas-heading gap-x-10 text-center">
                    <h2 className="chartHeading !text-lg !font-medium w-full">
                      Customize Generator Parameters
                    </h2>
                  </div>
                  <DeficitBidTable
                    // setModalFilter={setModalFilter}
                    handleUpdateReview={handleUpdateReview}
                    loading={submitLoading}
                    setModalOpen={setModalOpen}
                    mode={"edit"}
                    handleSubmit={handleUpdateReview}
                    maxHeight="calc(-60px + 100vh)"
                    data={bidData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}
